
export const footer = {
  'footer.allRightsReserved': 'Tous droits réservés.',
} as const;
